var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticStyle:{"height":"100%"}},[_c('el-dialog',{staticClass:"look-url",attrs:{"visible":_vm.show,"title":_vm.name,"width":"90%","top":"3vh"},on:{"update:visible":function($event){_vm.show=$event}}},[_c('iframe',{staticStyle:{"border":"medium none"},attrs:{"src":_vm.url,"height":"100%","width":"100%"}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }